import React, { createContext, useContext, useState, useMemo } from 'react';

interface ScreenshotContextType {
  isCapturingScreenshot: boolean;
  setCapturingScreenshot: (value: boolean) => void;
}

const ScreenshotContext = createContext<ScreenshotContextType>({
  isCapturingScreenshot: false,
  setCapturingScreenshot: () => {},
});

export const ScreenshotProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isCapturingScreenshot, setCapturingScreenshot] = useState(false);

  const value = useMemo(
    () => ({
      isCapturingScreenshot,
      setCapturingScreenshot,
    }),
    [isCapturingScreenshot],
  );

  return (
    <ScreenshotContext.Provider value={value}>
      {children}
    </ScreenshotContext.Provider>
  );
};

export const useScreenshotContext = (): ScreenshotContextType => {
  const context = useContext(ScreenshotContext);
  if (!context) {
    throw new Error(
      'useScreenshotContext must be used within a ScreenshotProvider',
    );
  }
  return context;
};

export default ScreenshotContext;
